export const LOCALES = {
  KR: 'kr',
  EN: 'en',
};

const EN_MAP = {
  '박희준': 'Park Hee Jun',
  '기술 스택': 'Tech Stack',
  '프로젝트': 'Projects',
  '전체보기': 'View All',
  '닫기': 'Close',
  '기간': 'Period',
  '프로젝트 아카이브': 'Project Archive',
  '기술스택': 'Tech Stack',
  '프로젝트 구성도': 'Architecture',
  '기여': 'Contributions',
  '프로토타입': 'Prototype',
  '소개영상': 'Intro Video',
  '성과': 'Results',
  '경력 / 경험': 'Career / Experience',
  '수상 / 자격 인증': 'Awards / Certifications',
  '경력': 'Career',
  '수상': 'Award',
  '자격': 'Certification',
  '증빙 보기': 'View Proof',
  '증빙 열기': 'Open Proof',
  '맨 위로 이동': 'Back to top',
  '유효기간: 2024.09.20 ~ 2026.09.20': 'Validity: 2024.09.20 ~ 2026.09.20',
  '2024.09.20 취득': 'Acquired on 2024.09.20',
  '실무 환경에서 제품 소프트웨어 설계 & 개발 & 검증까지 전반적인 개발을 통해 무기체계 연구 및 개발 진행': 'Researched and developed defense systems by leading end-to-end product software design, implementation, and verification in real-world environments.',
  '소프트웨어 개발 프로세스인 V모델을 활용한 체계 종합 연구': 'Conducted integrated system research using the V-model software development lifecycle.',
  '실시간 처리가 필요한 시스템 소프트웨어 개발': 'Developed system software for real-time processing requirements.',
  '다양한 업체와의 협업을 통한 제품 완성도 상향': 'Improved product quality through cross-company collaboration.',
  '삼성청년소프트웨어 아카데미 (SSAFY)': 'Samsung Software Academy for Youth (SSAFY)',
  '임베디드 & 펌웨어 개발 역량 강화 및 팀 프로젝트 주도': 'Strengthened embedded and firmware capabilities while leading team projects.',
  '최우수(상위 5%) 수료': 'Completed with highest distinction (top 5%).',
  'S/W 역량테스트 Professional 등급 달성': 'Achieved Professional grade in the software competency test.',
  'The Lee, Javix, Leafree 팀 프로젝트 설계 및 구현': 'Designed and implemented The Lee, Javix, and Leafree team projects.',
  'SSAFY 인증서': 'SSAFY Certificate',
  'SSAFY 인증서 (추가)': 'SSAFY Certificate (Additional)',
  '삼성청년소프트웨어아카데미(SSAFY) Embedded Track 수료/인증 자료': 'Completion and certification documents for SSAFY Embedded Track.',
  '실시간 시스템 환경에서 Edge TPU 기반 Embedded AI 연구를 수행': 'Conducted Edge TPU-based embedded AI research in real-time system environments.',
  'Coral Dev Board의 Driver Library 개별화 연구': 'Researched custom driver library adaptations for Coral Dev Board.',
  'Memory-Efficient Pipelined Parallelism in Edge TPUs on Real-time System 연구': 'Researched memory-efficient pipelined parallelism for Edge TPUs in real-time systems.',
  'Edge TPU 기반 On-device AI 구조 이해 및 추론 최적화 연구': 'Studied on-device AI architecture and optimized inference on Edge TPU.',
  '1기 Member': '1st Cohort Member',
  'Google Developer Student Club 1기 멤버로 개발 커뮤니티 활동에 참여했습니다.': 'Participated in developer community activities as a 1st cohort member of GDSC.',
  '개발 스터디 및 커뮤니티 활동 참여': 'Participated in development studies and community activities.',
  '동료 개발자와 기술 학습 및 프로젝트 경험 공유': 'Shared technical learning and project experience with peer developers.',
  '아주대학교': 'Ajou University',
  '디지털미디어학과(주전공) 및 소프트웨어학과(복수전공) 전공': 'Major in Digital Media with a double major in Software.',
  '소프트웨어 이론 및 실무 학습': 'Studied software theory and practical development.',
  'OpenCV, OpenGL을 통한 랜더링 알고리즘 학습 및 구현': 'Learned and implemented rendering algorithms using OpenCV and OpenGL.',
  '다양한 팀 프로그래밍 프로젝트 수행': 'Completed diverse team programming projects.',
  'KHUTON 대상': 'KHUTON Grand Prize',
  '실시간 고속도로 혼잡료 요금 부과 시스템': 'Real-time highway congestion toll system.',
  '2024 KHUTON 대상 상장': '2024 KHUTON Grand Prize Certificate',
  'SOFTCON 우수상': 'SOFTCON Excellence Award',
  '실시간 차량 디지털 트윈 시뮬레이션': 'Real-time vehicle digital twin simulation.',
  '2024 SOFTCON 우수상 상장': '2024 SOFTCON Excellence Award Certificate',
  '삼성전자 연계프로젝트 우수상 3등': 'Samsung-sponsored Project Excellence Award (3rd)',
  '멀티 디바이스 음성 이벤트 통합 비서 플랫폼 Javix': 'Javix: integrated assistant platform for multi-device voice events.',
  'Javix 우수상 3등 상장': 'Javix Excellence Award (3rd) Certificate',
  'SSAFY 자율프로젝트 우수상 1등': 'SSAFY Autonomous Project Excellence Award (1st)',
  '스마트팜 자동제어/음성 인터랙션 기반 Leafree 프로젝트': 'Leafree project based on smart farm automation and voice interaction.',
  'Leafree 우수상 1등 상장': 'Leafree Excellence Award (1st) Certificate',
  '삼성 SW 역량테스트 Professional': 'Samsung SW Competency Test Professional',
  '삼성 SW 역량테스트 Professional 등급 취득': 'Achieved Samsung SW Competency Test Professional grade.',
  '합격 메일': 'Pass Confirmation Email',
  '자격 현황': 'Certification Status',
  'Hackathon': 'Hackathon',
  '대상': 'Grand Prize',
  '실시간 시스템': 'Real-time Systems',
  '우수상': 'Excellence Award',
  '3등': '3rd Place',
  '1등': '1st Place',
  '상장': 'Certificate',
  '인증서': 'Certificate',
  '추가본': 'Additional',
  '합격': 'Pass',
  '메일': 'Email',
  '자격현황': 'Certification Status',
  '식물 관리 경험을 자동 제어와 음성 인터랙션으로 확장한 스마트팜 키트': 'A smart farm kit extending plant care through automation and voice interaction.',
  '환경 제어, 자동 급수, 음성 인식, AI 캐릭터, 원격 앱 제어를 하나의 스마트팜 키트에 담았습니다.': 'Integrated environment control, auto watering, voice recognition, AI character, and remote app control into one smart farm kit.',
  '팀 리드로서 전체 시스템 방향 정리': 'Aligned the overall system direction as team lead.',
  '센서 제어와 AI 인터페이스가 연결되는 흐름 조율': 'Coordinated the flow connecting sensor control and AI interface.',
  '디바이스와 원격 제어 경험이 함께 보이는 제품 구조 리드': 'Led product structure where device and remote control experiences are unified.',
  '멀티 디바이스 음성 이벤트를 하나의 AI 비서 경험으로 연결한 플랫폼': 'A platform that connects multi-device voice events into one AI assistant experience.',
  '다양한 디바이스에서 발생하는 음성 이벤트를 하나의 서비스 흐름으로 묶고 AI 비서와 연결했습니다.': 'Unified voice events across devices into a single service flow connected to an AI assistant.',
  '멀티디바이스 제어': 'Multi-device Control',
  '이벤트 라우팅': 'Event Routing',
  '상태 동기화': 'State Sync',
  '프로세스 제어': 'Process Control',
  '명령 분배': 'Command Dispatch',
  '서비스 연결': 'Service Integration',
  '멀티디바이스를 제어하는 미들웨어 제작': 'Built middleware for multi-device control.',
  '디바이스 이벤트를 처리하는 시스템 소프트웨어 구현': 'Implemented system software handling device events.',
  '서비스 계층과 연결되는 제어 흐름 설계': 'Designed control flow integrated with service layers.',
  '사무실 쓰레기 처리를 자동화하는 자율주행 로봇 시스템': 'An autonomous robot system that automates office waste handling.',
  '자율주행, 센서 상태 판단, 쓰레기 분류 AI, 웹·모바일 호출을 하나의 제품 경험으로 연결했습니다.': 'Connected autonomous driving, sensor status evaluation, waste classification AI, and web/mobile calls into one product experience.',
  '프로젝트 총괄과 팀 진행 방향 조율': 'Oversaw project execution and coordinated team direction.',
  'Jetson 환경 설정 및 라이다 테스트': 'Configured Jetson environment and performed LiDAR testing.',
  'ROS Mapping Stack 구현': 'Implemented ROS mapping stack.',
  'YOLOR-v8 모델 경량화': 'Lightweight optimization of YOLOR-v8 model.',
  'Edge TPU 기반 객체 탐지와 LiDAR 데이터를 결합한 실시간 3D 관제 시스템': 'A real-time 3D monitoring system combining Edge TPU object detection with LiDAR data.',
  'Raspberry Pi, Edge TPU, 카메라, LiDAR를 하나의 이동형 엣지 디바이스로 묶어 객체 정보와 거리 데이터를 3D 시뮬레이션으로 전송했습니다.': 'Integrated Raspberry Pi, Edge TPU, camera, and LiDAR into a mobile edge device that sends object and distance data to 3D simulation.',
  'Raspberry Pi 기반 이동형 엣지 디바이스 제작과 구현 리드': 'Led design and implementation of a Raspberry Pi-based mobile edge device.',
  '카메라, LiDAR, USB Accelerator를 활용한 데이터 센싱 및 처리 흐름 구축': 'Built sensing and processing pipelines using camera, LiDAR, and USB accelerator.',
  'Edge TPU 기반 YOLOv5 객체 탐지와 LiDAR 거리 데이터를 결합해 클래스·거리·각도 정보 산출': 'Derived class, distance, and angle by combining Edge TPU YOLOv5 detection with LiDAR distance data.',
  'C로 작성된 센서 드라이버를 Pybind로 모듈화해 Python 처리 파이프라인과 통합': 'Modularized C-based sensor drivers with Pybind and integrated them into Python processing pipeline.',
  'Edge TPU 캐싱과 추론을 분리해 실시간 시스템의 불필요한 추론 시간을 줄인 연구': 'Research that reduced unnecessary inference time in real-time systems by separating Edge TPU caching and inference.',
  'Edge TPU의 비효율적인 캐싱 흐름을 드라이버 단에서 분석하고, 캐싱과 추론을 분리한 뒤 Time-Triggered Cyclic Executive Scheduling 관점으로 다중 TPU 실행 시간을 맞췄습니다.': 'Analyzed inefficient Edge TPU caching flow at driver level, separated caching from inference, and aligned multi-TPU execution timing using time-triggered cyclic executive scheduling.',
  'Edge TPU의 캐싱을 위해 불필요한 추론이 발생하는 드라이버 흐름 분석': 'Analyzed driver flows causing unnecessary inference for Edge TPU caching.',
  '캐싱과 추론을 분리하기 위한 드라이버 함수 추가 및 실행 경로 정리': 'Added driver functions and organized execution paths to separate caching and inference.',
  '여러 TPU의 캐싱·추론 시간을 맞추기 위해 Time-Triggered Cyclic Executive Scheduling 방식 설계': 'Designed a time-triggered cyclic executive scheduling approach to align caching/inference timing across multiple TPUs.',
  'Large Dummy CNN Model 기준 서브모델별 평균 약 10% 추론 시간 감축 확인': 'Verified approximately 10% average inference time reduction per submodel on a large dummy CNN.',
  '차량 위험 상황을 센서로 판단하고 GPS 위치를 RF 통신으로 자동 전송한 임베디드 시스템': 'An embedded system that detects vehicle risk conditions and automatically transmits GPS location via RF.',
  '압력 센서와 가속도 센서로 위험 상황을 판단하고, GPS 위도·경도 데이터를 RF 모듈을 통해 서버로 전송하는 자동 신고 흐름을 구현했습니다.': 'Implemented an auto-report flow that detects risk using pressure/acceleration sensors and sends GPS coordinates to server via RF module.',
  '위험 상황 감지 후 GPS 신호를 위도·경도 데이터로 변환하는 기능 구현': 'Implemented conversion of GPS signals into latitude/longitude after risk detection.',
  'RF 모듈을 활용해 위험 이벤트와 위치 정보를 서버로 전송하는 흐름 담당': 'Handled the flow transmitting risk events and location information to server via RF module.',
  '압력 센서와 가속도 센서를 활용해 페달 조작과 차량 가속도를 비교하는 위험 판단 로직 구성': 'Built risk decision logic comparing pedal operation and vehicle acceleration using pressure and acceleration sensors.',
  '프로젝트 코드와 업데이트를 가장 빠르게 확인할 수 있는 저장소입니다.': 'Repository where project code and updates are available fastest.',
  '경력, 프로젝트 스토리, 기술 기반 협업 히스토리를 정리해두었습니다.': 'Curated career, project stories, and technical collaboration history.',
  '프로젝트 메이킹 과정과 개인 브랜딩 관련 포스트를 공유합니다.': 'Sharing project making process and personal branding posts.',
};

export const localizeText = (value, locale = LOCALES.KR) => {
  if (typeof value !== 'string') {
    return value;
  }

  if (locale !== LOCALES.EN) {
    return value;
  }

  return EN_MAP[value] ?? value;
};
